import { c as _c } from "react/compiler-runtime";
import { useEmailComposer } from "../../context";
import { storedAttributeProps } from "../html-attributes";
import { NodeViewContent, NodeViewWrapper } from "@tiptap/react";
import { getHeadingStyles } from "./styles";
interface Props {
  attrs: Record<string, unknown>;
  updateAttrs: (attrs: Record<string, unknown>) => void;
  selected: boolean;
}
export function HeadingTiptapView(t0) {
  const $ = _c(13);
  const {
    attrs,
    selected
  } = t0;
  const {
    styleSettings
  } = useEmailComposer();
  const Tag = `h${attrs.level as 1 | 2 | 3}` as const;
  const t1 = selected || undefined;
  let t2;
  if ($[0] !== attrs) {
    t2 = storedAttributeProps(attrs);
    $[0] = attrs;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== attrs || $[3] !== styleSettings) {
    t3 = getHeadingStyles(attrs, styleSettings);
    $[2] = attrs;
    $[3] = styleSettings;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <NodeViewContent />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== Tag || $[7] !== t2 || $[8] !== t3) {
    t5 = <Tag {...t2} style={t3}>{t4}</Tag>;
    $[6] = Tag;
    $[7] = t2;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t1 || $[11] !== t5) {
    t6 = <NodeViewWrapper data-block-type="emailHeading" data-selected={t1}>{t5}</NodeViewWrapper>;
    $[10] = t1;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}